const CLOUDINARY_HOST = 'res.cloudinary.com';
const UPLOAD_SEGMENT = '/image/upload/';

/**
 * Devuelve una URL de Cloudinary con transformaciones de entrega:
 *   f_auto  -> WebP/AVIF según el browser
 *   q_auto  -> calidad automática
 *   w_<n>   -> ancho acotado (c_limit evita agrandar)
 *
 * Si la URL no es de Cloudinary (por ejemplo un base64 legacy o una URL
 * externa), se devuelve tal cual para no romper la vista.
 */
export function cloudinaryImage(
  src: string | null | undefined,
  width = 400
): string {
  if (!src) return '';

  if (!src.startsWith('http') || !src.includes(CLOUDINARY_HOST)) {
    return src;
  }

  const uploadIndex = src.indexOf(UPLOAD_SEGMENT);
  if (uploadIndex === -1) return src;

  const prefix = src.slice(0, uploadIndex + UPLOAD_SEGMENT.length);
  const rest = src.slice(uploadIndex + UPLOAD_SEGMENT.length);

  // Si ya trae transformaciones, no las duplicamos. Se reconocen por los
  // prefijos estándar de Cloudinary (f_, q_, w_, c_, etc.), no por cualquier
  // carpeta que contenga un guion bajo.
  const firstSegment = rest.split('/')[0] ?? '';
  const transformationPrefix =
    /^(?:f|q|w|h|c|dpr|ar|g|e|b|co|r|t|pg|fl|so|x|y|z|if|dn|p|ac|af|cs|dl|du|eo|l|o)_/;
  const alreadyTransformed = transformationPrefix.test(firstSegment);

  if (alreadyTransformed) return src;

  const transform = `f_auto,q_auto,w_${Math.round(width)},c_limit`;
  return `${prefix}${transform}/${rest}`;
}
